import React, { useState, useEffect } from "react";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "react-emotion";
import { getMailChimpContentById } from "apis";
import { spliceChimpHTML } from "./spliceChimpHTML";

const moveBack50 = css`
  transform: translateX(-25px);
`;
const rotate90 = css`
  transform: translateX(-25px) rotate(90deg);
  margin-left: 0;
  margin-right: 20px;
`;

const faqWrapper = css`
  padding: 7px 0px;
  :not(:first-child) {
    border-top: 1px solid rgb(218, 218, 218);
  }
`;

const faqRow = css`
  width: 100%;
  color: #89d2d3;
  display: flex;
  flex-wrap: wrap;
  min-height: 35px;
  line-height: 35px;
  cursor: pointer;
  text-align: left;
`;

const faqCol = css`
  font-size: 1em;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  line-height: 35px;
`;

const previewContainer = css`
  color: black;
  font-size: 14px;
`;

const questionStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
`;

function NewsLetterObject({ qaObj, ...props }) {
  const [showDetails, setShowDetails] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [answer, setAnswer] = useState("");

  const id = qaObj ? qaObj.id : "";
  const question = qaObj ? qaObj.subjectLine : "";
  const previewText = qaObj ? qaObj.previewText : "";
  const date = qaObj ? qaObj.createdAt : "";
  let dateString = "";
  if (date != "") {
    const dateObject = new Date(date);
    dateString = dateObject.toLocaleDateString();
  }

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const getCaretClass = () => {
    if (hovered && !showDetails) {
      return moveBack50;
    } else if (showDetails) {
      return rotate90;
    }
    return null;
  };

  const getCampaignContent = async (id) => {
    try {
      const result = await getMailChimpContentById(id);
      setAnswer(spliceChimpHTML(result.html));
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (showDetails && answer == "") {
      getCampaignContent(id);
    }
  }, [showDetails]);
  const spliceHTML = () => {
    if (answer != "" && showDetails && id != "a3f2594905") {
      if (document.getElementById("templateFooter"))
        document.getElementById("templateFooter").remove();
    }
  };
  if (showDetails && answer != "") {
    spliceHTML();
  }

  return (
    <div className={faqWrapper}>
      <div
        className={faqRow}
        onClick={toggleDetails}
        onMouseOver={() => {
          setHovered(true);
        }}
        onMouseOut={() => {
          setHovered(false);
        }}
      >
        <div className={faqCol}>
          {question ? question : null}
          <div
            style={{
              fontSize: "0.9375rem",
              color: "#adadad",
              lineHeight: "normal",
            }}
          >
            {dateString ? dateString : null}
          </div>
          <div className={previewContainer}>
            <p>{previewText && !showDetails ? previewText : null}</p>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 auto",
            width: "auto",
            maxWidth: "100%",
            position: "relative",
            paddingLeft: "15px",
          }}
        >
          {" "}
          <ListItemIcon
            style={{
              color: "#89d2d3",
            }}
          >
            <span
              style={{
                fontSize: "1.5rem",
                display: "block",
                transition: "all 0.2s ease-in-out",
                marginLeft: "20px",
              }}
              className={getCaretClass()}
            >
              <FontAwesomeIcon icon="angle-right" />
            </span>
          </ListItemIcon>
        </div>
      </div>
      <div className={faqCol} style={{ textAlign: "left" }}>
        {showDetails ? (
          <div
            dangerouslySetInnerHTML={{
              __html: answer,
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

export default NewsLetterObject;
